export const getItemCustomizedPrice = (item, orderObj, size = null) => {
  // For non-half items with simple structure (itemType 0), use payablePrice
  if (!item.isHalf && (!item.itemType || item.itemType === 0)) {
    return item.payablePrice ? parseFloat(item.payablePrice).toFixed(2) : '0.00';
  }

  // For complex items and half items, calculate the price properly
  const selectedSize = size || item.selectedSizes?.[0];
  if (!selectedSize && !item.isHalf) {
    return item.payablePrice ? parseFloat(item.payablePrice).toFixed(2) : '0.00';
  }

  let itemPrice = 0;
  let quantity = 0;
  let halfQuantity = 0;
  let extraPrice = 0;
  let extraPriceHalf = 0;
  let currentItem = JSON.parse(JSON.stringify(item));

  if (!currentItem.itemType || currentItem.itemType === 0) {
    // Handle simple items with sizes
    currentItem.selectedSizes &&
      currentItem.selectedSizes.forEach((sizeItem) => {
        if (!selectedSize || sizeItem._id === selectedSize._id) {
          if (sizeItem.quantity > 0) {
            quantity = quantity + sizeItem.quantity;
            itemPrice = itemPrice + sizeItem.quantity * Number(sizeItem.price);
          }
          if (sizeItem.variants) {
            sizeItem.variants.forEach((v) => {
              if (v.quantity && Number(v.quantity) > 0)
                itemPrice = itemPrice + sizeItem.quantity * Number(v.price);
            });
          }
        }
      });
    if (quantity > 0) {
      currentItem.selectedExtraIngredients &&
        currentItem.selectedExtraIngredients.forEach((ingredient) => {
          if (ingredient.quantity > 0) {
            extraPrice =
              extraPrice + Number(ingredient.quantity) * Number(ingredient.price);
          }
        });
      itemPrice = extraPrice * quantity + itemPrice;
    }
  } else {
    // Handle complex items with modifiers
    currentItem.selectedModifiers &&
      currentItem.selectedModifiers.forEach((m) => {
        m && m.subModifiers && m.subModifiers.forEach((s) => {
          if (m._id === currentItem.baseModifierId) {
            quantity = s.quantity;
            itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
            if (s.variants) {
              s.variants.forEach((v) => {
                itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
              });
            }
          } else {
            if (s.prices) {
              s.prices.forEach((p) => {
                itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                if (p.variants) {
                  p.variants.forEach((v) => {
                    itemPrice =
                      itemPrice + Number(v.quantity) * Number(v.price);
                  });
                }
              });
            }
          }
        });
      });
    if (quantity > 0) {
      currentItem.selectedExtraIngredients &&
        currentItem.selectedExtraIngredients.forEach((ingredient) => {
          if (ingredient.quantity > 0) {
            extraPrice =
              extraPrice + Number(ingredient.quantity) * Number(ingredient.price);
          }
        });
      itemPrice = extraPrice * quantity + itemPrice;
    }
  }

  // Handle half items if applicable
  if (
    currentItem.isHalf &&
    (!currentItem.itemTypeHalf || currentItem.itemTypeHalf === 0)
  ) {
    currentItem.selectedSizesHalf &&
      currentItem.selectedSizesHalf.forEach((sizeItem) => {
        if (sizeItem.quantity > 0) {
          halfQuantity = halfQuantity + sizeItem.quantity;
          itemPrice = itemPrice + sizeItem.quantity * Number(sizeItem.price);
        }
        if (sizeItem.variants) {
          sizeItem.variants.forEach((v) => {
            if (v.quantity && Number(v.quantity) > 0)
              itemPrice = itemPrice + sizeItem.quantity * Number(v.price);
          });
        }
      });
    if (halfQuantity > 0) {
      currentItem.selectedExtraIngredientsHalf &&
        currentItem.selectedExtraIngredientsHalf.forEach((ingredient) => {
          if (ingredient.quantity > 0) {
            extraPriceHalf = extraPriceHalf + ingredient.quantity * ingredient.price;
          }
        });
      itemPrice = extraPriceHalf * halfQuantity + itemPrice;
    }
  } else if (currentItem.isHalf && currentItem.itemTypeHalf === 1) {
    currentItem.selectedModifiersHalf &&
      currentItem.selectedModifiersHalf.forEach((m) => {
        m && m.subModifiers && m.subModifiers.forEach((s) => {
          if (m._id === currentItem.baseModifierIdHalf) {
            halfQuantity = s.quantity;
            itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
            if (s.variants) {
              s.variants.forEach((v) => {
                itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
              });
            }
          } else {
            if (s.prices) {
              s.prices.forEach((p) => {
                itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                if (p.variants) {
                  p.variants.forEach((v) => {
                    itemPrice =
                      itemPrice + Number(v.quantity) * Number(v.price);
                  });
                }
              });
            }
          }
        });
      });
    if (halfQuantity > 0) {
      currentItem.selectedExtraIngredientsHalf &&
        currentItem.selectedExtraIngredientsHalf.forEach((ingredient) => {
          if (ingredient.quantity > 0) {
            extraPriceHalf = extraPriceHalf + ingredient.quantity * ingredient.price;
          }
        });
      itemPrice = extraPriceHalf * halfQuantity + itemPrice;
    }
  }

  // Add half-half additional charges if applicable
  if (currentItem.isHalf) {
    itemPrice =
      itemPrice +
      (orderObj.halfHalfAdditionalCharges
        ? Number(orderObj.halfHalfAdditionalCharges)
        : 0) *
        (quantity + halfQuantity);
  }

  return itemPrice.toFixed(2);
}; 